import './App.css';
import Main from './components/Main'
import MainModels from "./components/MainModels";
import React from 'react';
import OverviewTable from "./components/OverviewTable";


// function App() {
//   return (
//     <Main />
//   );
// }

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      path: "",
      domain:  ""//"http://127.0.0.1:8000/" //
    };
  }

  componentDidMount() {
    // const query = new URLSearchParams(window.location.search);
    // console.log(window.location.pathname)

    this.setState({
      path: window.location.pathname
    })
  }

  render() {
    const { path, domain} = this.state;
    return (
        <div>
          <div className="App">
            {path==="/main" || path==="/"?
                <Main domain={domain} key={"datasets_view"}/>:null
            }
            {path==="/model"?
                <MainModels domain={domain} key={"mainmodels_view"} />:null
            }
            {path==="/all"?
                <OverviewTable domain={domain} key={"overview_table_view"}/>:null
            }
            {/*{path==="/article"?*/}
            {/*    <Resolve/>:null*/}
            {/*}*/}
          </div>
        </div>
    );
  }
}

export default App;
